var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg40Dc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204.808,
    height: 160.366,
    viewBox: "0 0 204.808 160.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 57.642,
    height: 25.373,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fcl_dc40",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M204.905,211.146a1,1,0,0,1,0-.493l.657-4.594a.407.407,0,0,1,.277-.372.372.372,0,0,1,.476.251.467.467,0,0,1,0,.2l-.623,4.395h0l1.644-.493a.052.052,0,0,0,0-.069l-.389-1.3a.4.4,0,0,1,.761-.234l.389,1.3a.052.052,0,0,0,.069,0l.363-.112a.365.365,0,0,1,.208.7l-.363.112a.052.052,0,0,0,0,.069l.216.709a.4.4,0,0,1-.761.234l-.216-.709a.052.052,0,0,0-.069,0l-2.137.64a.381.381,0,0,1-.5-.234Z",
    transform: "translate(-100.808 -56.665)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M210.226,207.713a7.423,7.423,0,0,1-.476-2.068,1.895,1.895,0,0,1,3.391-1.021,15.762,15.762,0,0,1,1.22,4.049,1.886,1.886,0,0,1-3.391,1.021A7.44,7.44,0,0,1,210.226,207.713Zm2.6,1.938a.96.96,0,0,0,.753-.865,18.166,18.166,0,0,0-1.125-3.737,1.064,1.064,0,0,0-1.877.562,18.167,18.167,0,0,0,1.125,3.737.96.96,0,0,0,1.116.3Z",
    transform: "translate(-101.465 -56.424)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M219.806,203.492a.326.326,0,0,1,.19.623l-.649.2a.052.052,0,0,0,0,.069l1,3.331a.4.4,0,0,1-.761.234l-1-3.331a.052.052,0,0,0-.069,0l-.242.078a.326.326,0,1,1-.19-.623l.242-.078a.052.052,0,0,0,0-.069l-.112-.381c-.311-1.047,0-1.523.926-1.8h.061a.363.363,0,0,1,.51.234.355.355,0,0,1-.268.467c-.562.173-.64.311-.484.865l.13.433a.052.052,0,0,0,.069,0Z",
    transform: "translate(-102.558 -56.13)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M224.181,207.137c-.865.268-1.332,0-1.609-.917l-.735-2.448a.052.052,0,0,0-.069,0l-.242.078a.324.324,0,1,1-.182-.623l.242-.078a.052.052,0,0,0,0-.069l-.286-.96a.4.4,0,0,1,.77-.234l.285.96a.052.052,0,0,0,.069,0l.571-.173a.326.326,0,0,1,.19.623l-.571.173a.052.052,0,0,0,0,.069l.727,2.422c.138.467.3.562.761.424a.355.355,0,0,1,.484.242c.061.208,0,.4-.3.476Z",
    transform: "translate(-102.998 -56.116)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M152.991,209.78l-3.261,3.512,4.161,2.362",
    transform: "translate(-93.369 -57.219)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M256.23,186.534l3.261-3.5-4.161-2.37",
    transform: "translate(-107.614 -53.291)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    y1: 26.325,
    x2: 95.516,
    transform: "translate(56.361 129.739)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x2: 6.203,
    transform: "translate(145.441 7.786)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M201.335,104.6l-4.905-6.973,49.5-17.683,49.51,17.683L277.006,123.8",
    transform: "translate(-99.668 -39.704)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M290.022,108.781,246.828,92.95,205.32,106.835",
    transform: "translate(-100.868 -41.459)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M215.923,89.534,207.48,78.279V67.63h79.883V78.279l-8.426,11.255",
    transform: "translate(-101.159 -38.044)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 42.104,
    height: 14.006,
    transform: "translate(125.215 15.58)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M195,130.64c5.069,0,5.069,3.339,10.139,3.339s5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-99.475 -46.543)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    y2: 47.857,
    transform: "translate(146.263 40.236)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 12.397,
    height: 15.58,
    transform: "translate(139.238)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    y1: 3.547,
    transform: "translate(132.94 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    y1: 3.547,
    transform: "translate(141.401 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    y1: 3.547,
    transform: "translate(149.87 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    y1: 3.547,
    transform: "translate(158.331 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9165",
    "data-name": "Group 9165",
    transform: "translate(145.917 86.796)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M195,141.64c5.069,0,5.069,3.339,10.139,3.339s5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-245.392 -134.823)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M145.1,189.493v-72.7l4.646-.234-.017,1.2,85.861-6.324v-1.367l3.443-.208-.009,55.116Z",
    transform: "translate(-92.744 -43.74)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M230.5,111.412l-49.726-3.192L84.58,114.535V128.3",
    transform: "translate(-84.58 -43.519)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M146.06,124.451l4.248-.311v61.1l-4.248,1.038",
    transform: "translate(-92.874 -45.667)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M171.277,180.454v-58.2l-4.057.355v58.81Z",
    transform: "translate(-95.728 -45.412)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M160.807,182.927V123.27l-4.057.346v60.272Z",
    transform: "translate(-94.316 -45.549)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M177.16,179.238l3.858-.934V121.38l-3.858.346Z",
    transform: "translate(-97.069 -45.294)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M187.6,176.931l3.642-.882V120.5l-3.642.32Z",
    transform: "translate(-98.477 -45.176)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M198.03,174.63l3.434-.839V119.61l-3.434.294Z",
    transform: "translate(-99.884 -45.056)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M208.22,172.376l3.227-.787V118.74l-3.227.277Z",
    transform: "translate(-101.259 -44.938)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M218.17,170.185l3.019-.744V117.89l-3.019.26Z",
    transform: "translate(-102.601 -44.824)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M227.63,168.09l2.812-.675V117.17l-2.812.242Z",
    transform: "translate(-103.877 -44.726)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M236.61,166.121l2.6-.657V116.49l-2.6.225Z",
    transform: "translate(-105.089 -44.635)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M245.35,164.2l2.379-.58V115.83l-2.379.208Z",
    transform: "translate(-106.268 -44.546)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 0.381,
    cy: 0.926,
    rx: 0.381,
    ry: 0.926,
    transform: "translate(54.32 75.03)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M84.58,173.791,137,190.2V117.525L84.58,115.44Z",
    transform: "translate(-84.58 -44.493)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M87.82,120.62V170.7l46.4,13.7V123.682Z",
    transform: "translate(-85.017 -45.192)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x2: 0.078,
    y2: 54.432,
    transform: "translate(25.962 77.729)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    y2: 62.331,
    transform: "translate(40.158 76.034)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    y2: 59.735,
    transform: "translate(29.829 75.446)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    y2: 57.59,
    transform: "translate(21.818 75.272)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    y2: 54.977,
    transform: "translate(11.662 74.814)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M87.205,118.165c0,.424-.164.744-.372.718s-.363-.407-.363-.865.164-.744.363-.718S87.205,117.741,87.205,118.165Z",
    transform: "translate(-84.835 -44.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M142.622,121.071c0,.554-.216.969-.476.926s-.476-.528-.476-1.081.216-.969.476-.926S142.622,120.517,142.622,121.071Z",
    transform: "translate(-92.281 -45.106)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M91.37,128.14V132.4l15.944,1.661v-4.239Z",
    transform: "translate(-85.496 -46.206)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M119.46,131.1v4.23l16.238,1.7v-4.239Z",
    transform: "translate(-89.285 -46.606)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M119.46,154.19v3.91l16.16,2.959v-3.91Z",
    transform: "translate(-89.285 -49.72)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M119.46,175.11v3.607L135.4,182.6v-3.607Z",
    transform: "translate(-89.285 -52.542)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M91.37,149.05v3.919l15.944,2.907v-3.91Z",
    transform: "translate(-85.496 -49.027)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M91.37,168.27v3.573l15.944,3.928v-3.616Z",
    transform: "translate(-85.496 -51.62)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M253.83,116.6v15.717",
    transform: "translate(-107.412 -44.649)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg40Dc);
export default __webpack_public_path__ + "static/media/40dc.3d7e5c0f6f1ece90c963335217c8272e.svg";
export { ForwardRef as ReactComponent };